module.exports = __webpack_public_path__ + "static/img/home_banner.fbbc257.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h5/home_banner.png
// module id = bdmF
// module chunks = 0